import { GENDER_CONFIRMED_THRESHOLD } from "@signalist/shared-types";

// One threshold for the gender chip, the salutation columns and the message variables (PREC-4416).
export { GENDER_CONFIRMED_THRESHOLD };

export type GenderConfidenceState = "confirmed" | "unsure" | "empty";

export const getGenderConfidenceState = (
	gender: string | null | undefined,
	genderProbability: number | null | undefined
): GenderConfidenceState => {
	if (!gender) {
		return "empty";
	}

	if (typeof genderProbability === "number" && genderProbability >= GENDER_CONFIRMED_THRESHOLD) {
		return "confirmed";
	}

	return "unsure";
};
